import { captureException } from '@sentry/react'
import { Tile, TileSnapshot, buildFeedRef } from '../types/feedRef'
import { MULTIVIEW_LIMITS, SESSION_COLORS } from '../config'
import { DecodedState } from './persistence.v2'
import { generateTileId, tryParseStreamId } from './feedId'

const LEGACY_FEED_SEPARATOR = '~'

export const migrateLegacyState = (raw: string | undefined): DecodedState => {
  if (!raw || raw.trim() === '') return { tiles: [], colors: {} }
  try {
    const tiles: Tile[] = []
    const colors: Record<string, number> = {}
    const parts = raw.split(',').filter(Boolean)
    for (const part of parts) {
      const segments = part.trim().split(LEGACY_FEED_SEPARATOR)
      if (segments.length < 2) continue
      const sessionId = segments[0]
      const streamId = segments[1]
      const colorIndexStr = segments[2]
      const colorIndex =
        colorIndexStr !== undefined ? parseInt(colorIndexStr, 10) : undefined
      if (!sessionId || !streamId) continue
      const parsed = tryParseStreamId(streamId)
      if (!parsed) continue
      const { componentId, padName } = parsed
      const snapshot: TileSnapshot = { displayName: '', componentType: null }
      tiles.push({
        tileId: generateTileId(),
        ref: buildFeedRef({ kind: 'session', sessionId }, componentId, padName),
        snapshot,
      })
      if (
        colorIndex !== undefined &&
        !isNaN(colorIndex) &&
        colorIndex >= 0 &&
        colorIndex < SESSION_COLORS.length
      ) {
        colors[`s:${sessionId}`] = colorIndex
      }
      if (tiles.length >= MULTIVIEW_LIMITS.maxFeeds) break
    }
    return { tiles, colors }
  } catch (error) {
    captureException(error, {
      tags: { feature: 'multiview', action: 'migrateLegacy' },
      extra: { raw },
    })
    return { tiles: [], colors: {} }
  }
}
